import React, { ReactElement } from 'react';
import {
  CalendarArrowUpIcon,
  CalendarIcon,
  CalendarSearchIcon,
  CircleCheckIcon,
  DotIcon,
  RefreshCwIcon,
} from 'lucide-react';
import { differenceInWeeks } from 'date-fns';
import { formatDate } from '../../dateFormat';
import { CourseCardType } from './ProgramCourseCard';

const TypeToElement: Record<CourseCardType, ReactElement> = {
  [CourseCardType.COMPLETED]: (
    <>
      <div className="text-success">{CourseCardType.COMPLETED}</div>
      <CircleCheckIcon className="text-success" />
    </>
  ),
  [CourseCardType.ONGOING]: (
    <>
      <div className="text-warning">{CourseCardType.ONGOING}</div>
      <RefreshCwIcon className="text-warning" />
    </>
  ),
  [CourseCardType.NEXT_CLASS]: (
    <>
      <div className="text-primary">{CourseCardType.NEXT_CLASS}</div>
      <CalendarArrowUpIcon className="text-primary" />
    </>
  ),
  [CourseCardType.TBA]: (
    <>
      <div className="text-popover-foreground">{CourseCardType.TBA}</div>
      <CalendarSearchIcon className="text-popover-foreground" />
    </>
  ),
};

interface Props {
  icon: ReactElement;
  abbreviation?: string;
  name: string;
  description: string;
  status: CourseCardType;
  startDate?: Date;
  endDate?: Date;
}

export const UniversityProgramCourseCard = ({
  icon,
  abbreviation,
  name,
  description,
  status,
  startDate,
  endDate,
}: Props) => {
  return (
    <div className="flex lg:flex-row flex-col p-4 gap-2">
      <div className="flex gap-4 flex-1">
        <div>{icon}</div>
        <div>
          <div className="font-semibold text-base text-heading">
            {abbreviation && `${abbreviation}: `}
            {name}
          </div>
          <div className="text-sm text-popover-foreground">{description}</div>
          {startDate && (
            <div className="flex flex-wrap gap-1 items-center text-sm text-foreground font-medium mt-1">
              <CalendarIcon size={16} className="text-popover-foreground" />
              <span>{formatDate(startDate)}</span>
              {endDate && (
                <>
                  <DotIcon />
                  <span>{differenceInWeeks(endDate, startDate)} weeks</span>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <div className="sm:min-w-[160px] font-semibold flex gap-2 justify-end items-center self-start">
        {TypeToElement[status]}
      </div>
    </div>
  );
};
